import React, { useEffect, useState } from "react";
import FileUploader from "react-firebase-file-uploader";
import * as firebase from "firebase/app";

export default ({ value, onChange }) => {
  const [itens, setItens] = useState([]);

  useEffect(() => {
    if (value) setItens(value);
  }, []);

  useEffect(() => {
    onChange(itens);
    console.log("change", itens);
  }, [itens]);

  const addItem = () => {
    setItens((itens) =>
      itens.concat([
        {
          description: "",
          type: "",
          url: "",
        },
      ])
    );
  };

  const removeItem = (item) => {
    var result = window.confirm("Deseja cancelar item?");

    if (result) setItens((itens) => itens.filter((_item) => _item != item));
  };

  const register = (name, item) => {
    return {
      value: item[name],
      onChange: (e) => {
        const value = e.target.value;
        setItens((itens) =>
          itens.map((_item) =>
            _item != item
              ? _item
              : {
                  ...item,
                  [name]: value,
                }
          )
        );
      },
    };
  };
  return (
    <div className="p-4">
      {itens.map((item, index) => (
        <div
          className="form-group p-4 rounded position-relative"
          style={{ background: "rgba(0,0,0,.1)" }}
          key={index}
        >
          <label
            className="text-danger font-weight-bold cursor-pointer"
            style={{
              position: "absolute",
              right: 16,
              top: 16,
              cursor: "pointer",
            }}
            onClick={() => removeItem(item)}
          >
            Excluir
          </label>
          <label>Item #{index + 1}</label>
          <div className="form-group    ">
            <label>Descricao</label>
            <input
              className="form-control"
              {...register("description", item)}
            />
          </div>
          <div className="form-group">
            <label>Tipo</label>
            <input className="form-control" {...register("type", item)} />
          </div>
          <div className="form-group">
            <label>Imagem</label>
            <FileUploader
              accept="image/*"
              name="avatar"
              randomizeFilename
              storageRef={firebase.storage().ref("result")}
              //   onUploadStart={this.handleUploadStart}
              //   onUploadError={this.handleUploadError}
              onUploadSuccess={async (filename, args) => {
                const { uploadUrl_ } = args;
                const { onChange } = register("url", item);

                const downloadURL = await firebase
                  .storage()
                  .ref("result")
                  .child(filename)
                  .getDownloadURL();

                onChange({
                  target: {
                    value: downloadURL,
                  },
                });
              }}
              onUploadError={console.log}
              //   onProgress={this.handleProgress}
            />
          </div>
          <br />
          {item.url && (
            <img
              style={{
                maxHeight: 200,
                width: "auto !important",
              }}
              src={item.url}
            />
          )}
        </div>
      ))}

      <button className="btn btn-primary w-100" onClick={addItem}>
        Adicionar item
      </button>
    </div>
  );
};
